import { Link } from "react-router-dom";
import { Info, ArrowRight } from "lucide-react";
import { ROUTES, PRODUCTS } from "../site";
import { usePageMeta } from "../hooks/usePageMeta";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Breadcrumbs from "../components/Breadcrumbs";
import ProductCard from "../components/ProductCard";
import WavyDivider from "../components/WavyDivider";

const meta = ROUTES[1];

export default function Produk() {
  usePageMeta(meta.title, meta.description);

  return (
    <div data-testid="produk-page">
      <Header />
      <main>
        <Breadcrumbs current="Produk" />
        <section className="container-site pb-12 pt-8 sm:pb-16">
          <span className="eyebrow-chip">Katalog Produk</span>
          <h1 className="mt-4 max-w-3xl text-balance font-display text-4xl font-extrabold leading-tight tracking-tight text-plum sm:text-5xl">
            Varian Yupi Burger yang Bisa Kamu Temukan
          </h1>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-plum-soft sm:text-lg">
            Tiga varian gummy burger dengan karakter berbeda — dari yang mini dan ikonik, yang jumbo
            dan bikin puas, sampai edisi spesial bertema cinta.
          </p>
        </section>

        <section aria-label="Daftar produk" className="container-site pb-14 sm:pb-20">
          <div className="grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-8">
            {PRODUCTS.map((product) => (
              <ProductCard key={product.id} product={product} detailed />
            ))}
          </div>
        </section>

        <section aria-labelledby="banding-heading" className="bg-bun-soft">
          <WavyDivider fill="#FFFDF9" flip />
          <div className="container-site py-14 sm:py-20">
            <h2
              id="banding-heading"
              className="text-center font-display text-2xl font-bold tracking-tight text-plum sm:text-3xl"
            >
              Bandingkan Ketiga Varian
            </h2>
            <div className="mt-10 overflow-x-auto rounded-3xl border-2 border-plum/10 bg-white shadow-gummy">
              <table className="w-full min-w-[560px] text-left text-sm" data-testid="product-comparison-table">
                <thead>
                  <tr className="border-b-2 border-plum/10 font-display text-base text-plum">
                    <th scope="col" className="px-6 py-4">Varian</th>
                    <th scope="col" className="px-6 py-4">Ukuran</th>
                    <th scope="col" className="px-6 py-4">Cara Makan Seru</th>
                    <th scope="col" className="px-6 py-4">Momen Pas</th>
                  </tr>
                </thead>
                <tbody className="text-plum-soft">
                  <tr className="border-b border-plum/5">
                    <th scope="row" className="px-6 py-4 font-display font-bold text-plum">Yupi Burger</th>
                    <td className="px-6 py-4">Mini, sekali gigit</td>
                    <td className="px-6 py-4">Gigit langsung atau lepas lapis demi lapis</td>
                    <td className="px-6 py-4">Camilan harian &amp; bekal</td>
                  </tr>
                  <tr className="border-b border-plum/5">
                    <th scope="row" className="px-6 py-4 font-display font-bold text-plum">Yupi Burger Max</th>
                    <td className="px-6 py-4">Jumbo, lebih besar</td>
                    <td className="px-6 py-4">Dimakan utuh atau dikupas sampai puas</td>
                    <td className="px-6 py-4">Buat yang pengen lebih puas</td>
                  </tr>
                  <tr>
                    <th scope="row" className="px-6 py-4 font-display font-bold text-plum">Yupi Gummy Love Burger</th>
                    <td className="px-6 py-4">Spesial bertema cinta</td>
                    <td className="px-6 py-4">Dinikmati pelan-pelan atau dibagi ke orang tersayang</td>
                    <td className="px-6 py-4">Hadiah &amp; momen spesial</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div
              data-testid="produk-price-disclaimer"
              className="mx-auto mt-8 flex max-w-3xl items-start gap-3 rounded-3xl border-2 border-cheese-dark/30 bg-cheese-soft p-5 text-sm leading-relaxed text-plum"
            >
              <Info className="mt-0.5 h-5 w-5 shrink-0 text-bun-dark" aria-hidden="true" />
              <p>
                Harga jual dan ketersediaan varian dapat berbeda di setiap toko dan platform. Untuk
                harga terkini, cek{" "}
                <Link to="/beli/" className="font-bold text-patty underline underline-offset-2 hover:text-patty-dark">
                  halaman Dimana Beli
                </Link>{" "}
                atau kunjungi toko resmi Yupi.
              </p>
            </div>

            <div className="mt-10 text-center">
              <Link to="/beli/" data-testid="produk-cta-where-to-buy" className="btn-primary">
                Cari Tempat Beli
                <ArrowRight className="h-5 w-5" aria-hidden="true" />
              </Link>
            </div>
          </div>
          <WavyDivider fill="#FFFDF9" />
        </section>
      </main>
      <Footer />
    </div>
  );
}
